export default {
      id: "ic_rechercher-usage",
      viewBox: "0 0 35 35",
      url: "../dist/images/" + "sprite.svg#ic_rechercher-usage",
      toString: function () {
        return this.url;
      }
    }